const OrderStatusTemplate = ({
  templateModal: { order },
  templateEvents: { handleOrderDetailClick },
}) => {
  return (
    <div
      className="ds-container"
      style={{ display: "flex", justifyContent: "center", paddingBlock: "72px 96px" }}
    >
      <div className="ds-state" style={{ maxWidth: 520 }}>
        <span
          className="ico"
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "var(--brand-teal-50)",
            color: "var(--brand-teal)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </span>
        <h3 style={{ font: "var(--fw-bold) 26px var(--font-display)", color: "var(--brand-ink)" }}>
          Thank you for your order!
        </h3>
        <p>
          Your order id is{" "}
          <b className="ds-mono" style={{ color: "var(--brand-violet)" }}>
            {order?.generated_id || ""}
          </b>
          . Please get in touch with us using this id for more details.
        </p>
        <button onClick={handleOrderDetailClick} type="button" className="ds-btn ds-btn-primary ds-btn-lg">
          View order details
        </button>
      </div>
    </div>
  );
};

export default OrderStatusTemplate;
